import { Keys as CRMKeys } from './crm';
import { Keys as SignalsKeys } from './signals';

export const Keys = {
  Signals: SignalsKeys,
  CRM: CRMKeys,
};
